import posthog from "posthog-js";

const key: string = import.meta.env.VITE_POSTHOG_KEY ?? "";

export const initPostHog = (): void => {
  console.log("Initializing PostHog", key);
  if (!key) return;
  posthog.init(key, {
    api_host: "https://us.i.posthog.com",
    capture_heatmaps: true,
    autocapture: true,
  });
};

export const identifyUser = (
  stytchUserId: string,
  user: { email: string; displayName?: string | null; admin?: boolean | null },
  merchantId: string
): void => {
  if (!key) return;
  posthog.identify(stytchUserId, {
    email: user.email,
    name: user.displayName ?? undefined,
    admin: !!user.admin,
  });
  posthog.register({ merchant_id: merchantId });
};

export const resetUser = (): void => {
  if (key) posthog.reset();
};

export type TrackedEvent =
  | "analytics_viewed"
  | "analytics_banner_clicked"
  | "analytics_legacy_restored"
  | "analytics_period_changed"
  | "analytics_segment_opened"
  | "analytics_tenant_profile_opened"
  | "analytics_priorities_table_used"
  | "analytics_settlement_detail_opened"
  | "fianza_interest_clicked"
  | "induction_started"
  | "induction_step_viewed"
  | "induction_exit_confirmed"
  | "induction_submitted"
  | "support_faq_opened"
  | "support_whatsapp_clicked"
  | "onboarding_home_viewed"
  | "onboarding_step_clicked"
  | "onboarding_home_dismissed"
  | "onboarding_empty_state_clicked";

export const track = (
  event: TrackedEvent,
  properties?: Record<string, string | number | boolean>
): void => {
  if (key) posthog.capture(event, properties);
};
